angular.module("ainapp")
    .controller("AccountCostCentersController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Account Cost Center";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.ParentCostCenters = [];
            MainService.GetParentCostCenters().then(function (response) {
                $scope.ParentCostCenters = response.data;
            }, function (err) {});

            $scope.Init = function () {

                $scope.load = true;
                $scope.CostCenters = [];

                $scope.CurrentCostCenter = {
                    Name: "",
                    Level: 1,
                    Description: "",
                    Code: "",
                    ParentId: "",
                    IsActive: true,
                }

                $scope.ShowAddFix = false;
                $scope.ShowEditFix = false;
                $scope.SelectedGroup = {};

            }
            $scope.Init();


            $scope.treelistOptions = {
                dataSource: {
                    transport: {
                        read: function (o) {
                            MainService.AccountCostCentersInKendoTree($stateParams.AccountMasterId).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success([]);
                                toastr.error("NetworkError");
                            })
                        },
                    },
                    schema: {
                        model: {
                            id: "Id",
                            parentId: "ParentId",
                            fields: {
                                ParentId: {
                                    field: "ParentId",
                                    nullable: true
                                },
                                CostCenterName: {
                                    field: "CostCenterName",
                                    type: "string"
                                },
                                CostCenterCode: {
                                    field: "CostCenterCode",
                                    type: "string"
                                },
                                "AccountMaster.Name": {
                                    field: "AccountMasterName",
                                    type: "string"
                                },
                            },
                            expanded: false
                        }
                    }
                },

                editable: false,
                toolbar: ["excel"],
                height: 600,
                //resizable: true,
                sortable: true,
                //scrollable: true,
                filterable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                columns: [
                    {
                        field: "CostCenterCode",
                        title: "Cost Center Code",
                                        },
                    {
                        field: "CostCenterName",
                        title: "Cost Center Name",
                                        },
                    {
                        field: "AccountMaster.Name",
                        title: "Account",
                                        },
                    {
                        title: "Options",
                        template: "<button class=' btn-default btn-sm fa fa-plus' ng-click='ShowAddModel(dataItem)'>  <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccount(dataItem)'></button>  ",
                        width: '80px'
                        },

                                    ],
            };


            $scope.refreshForm = function () {

                $scope.CurrentCostCenter = {
                    Name: "",
                    Level: "",
                    Description: "",
                    ParentId: "",
                    Code: "",
                    IsActive: true,
                }
                $("#addCostModal").modal("hide");

            }

            $scope.ShowAddModel = function (data) {

                $scope.CurrentCostCenter = {
                    Level: 2,
                    CostCenterId: "",
                    AccountMasterId: $stateParams.AccountMasterId,
                    ParentId: data.Id,
                }

                $scope.SelectedGroup = data;

                $scope.ChildrenList = [];
                MainService.CostCenterSubList(data.CostCenterId).then(function (response) {
                    $scope.ChildrenList = response.data;
                }, function (err) {});


                $("#addCostModal").modal("show");

            }

            $scope.ShowAddMainModel = function () {

                $scope.CurrentCostCenter = {
                    CostCenterId: "",
                    AccountMasterId: $stateParams.AccountMasterId,
                    ParentId: null,
                }

                $("#addMainCostModal").modal("show");

            }

            $scope.ShowEditModel = function (data) {
                $scope.CurrentCostCenter = data;
                $("#addCostModal").modal("show");
            }


            $scope.saveCostCenter = function () {

                if ($scope.CurrentCostCenter.Name == "") {
                    toastr.warning("Give Cost Center Name");
                } else if ($scope.CurrentCostCenter.Code == "") {
                    toastr.warning("Give Cost Center Code");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddAccountCostCenter($scope.CurrentCostCenter).then(function (response) {
                        $scope.load = false;
                        if (response.data == "Success") {
                            toastr.success("Cost Center Saved");
                            $("#addMainCostModal").modal("hide");
                            $("#addCostModal").modal("hide");
                            $scope.ktl.dataSource.read();
                        } else {
                            toastr.error(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $scope.load = false;
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    });
                }

            }

            $scope.SelectedAccForDelete = {};
            $scope.DeleteAccount = function (data) {
                $scope.SelectedAccForDelete = data;
                $("#myModal2").modal("show");
            }

            $scope.deleteWithConfirm = function (temp) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteAccountCostCenter($scope.SelectedAccForDelete.Id, temp).then(function (response) {
                    if (response.data == "Success") {
                        $('#myModal2').modal('hide');
                        toastr.success("Deleted");
                        $scope.SelectedAccForDelete = {};
                        $scope.ktl.dataSource.read();

                    } else {
                        toastr.warning(response.data);
                        $scope.SelectedAccForDelete = {};
                        $('#myModal2').modal('hide');
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $scope.load = 0;
                    toastr.error("Network Error");
                    $.LoadingOverlay("hide");
                });
            }

        }])
